import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from './firebase';
import './Login.css';
import logo from './logo.png';

interface LoginProps {
  onLoginSuccess: () => void;
}

const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      
      // Lấy token để kiểm tra custom claim 'admin'
      const tokenResult = await user.getIdTokenResult();
      
      if (tokenResult.claims.admin === true) {
        onLoginSuccess();
      } else {
        setError('Bạn không có quyền truy cập vào trang quản trị');
        await auth.signOut();
      }
    } catch (error: any) {
      let errorMessage = 'Đã xảy ra lỗi trong quá trình đăng nhập';
      
      switch (error.code) {
        case 'auth/user-not-found':
          errorMessage = 'Không tìm thấy tài khoản với email này';
          break;
        case 'auth/wrong-password':
          errorMessage = 'Mật khẩu không chính xác';
          break;
        case 'auth/invalid-email':
          errorMessage = 'Email không hợp lệ';
          break;
        case 'auth/too-many-requests':
          errorMessage = 'Quá nhiều lần thử. Vui lòng thử lại sau';
          break;
        case 'auth/invalid-credential':
          errorMessage = 'Email hoặc mật khẩu không chính xác';
          break;
        case 'auth/network-request-failed':
          errorMessage = 'Lỗi kết nối mạng. Vui lòng kiểm tra internet';
          break;
        case 'auth/api-key-not-valid':
          errorMessage = 'Lỗi cấu hình Firebase API key';
          break;
        default:
          errorMessage = `Lỗi: ${error.code || 'unknown'} - ${error.message || 'Không xác định'}`;
          break;
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <div className="logo-container">
          <img src={logo} alt="Fconnect Logo" className="login-logo" />
        </div>
        <h1 className="login-title">Đăng nhập</h1>
        
        <form onSubmit={handleLogin}>
          <div className="input-group">
            <input
              type="email"
              placeholder="Nhập email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="login-input"
              required
            />
          </div>
          
          <div className="input-group">
            <input
              type="password"
              placeholder="Nhập mật khẩu"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
              required
            />
          </div>
          
          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Đang đăng nhập...' : 'Đăng nhập'}
          </button>
          
          {error && <div className="error-message">{error}</div>}
        </form>
      </div>
      
      <div className="login-links">
        <a href="/" className="login-link">Trang chủ</a>
        <a href="/privacy" className="login-link">Chính sách bảo mật</a>
        <a href="/terms" className="login-link">Điều khoản sử dụng</a>
        <a href="/contact" className="login-link">Liên hệ</a>
      </div>
      
      <div className="login-copyright">
        © 2025 Fconnect. Tất cả các quyền được bảo lưu.
      </div>
    </div>
  );
};

export default Login; 